<template>
  <div class="col-lg-12">
    <div class="panel blank-panel">
      <div class="panel-heading">
        <div class="panel-options">
          <ul class="nav nav-tabs">
            <li class="active"><a class="nav-link" href="#tab-2" data-toggle="tab" @click="activeComponent='projectTasks'">Tasks</a></li>
            <li><a class="nav-link" data-toggle="tab" @click="activeComponent='lastActivity'">Last Activity</a></li>
            <li><a class="nav-link" data-toggle="tab" @click="activeComponent='projectNotes'">Notes</a></li>
          </ul>
        </div>
      </div>
      <div class="panel-body">
        <div class="tab-content">
          <div class="tab-pane active">
            <div>
              <project-tasks v-if="activeComponent === 'projectTasks'" :project="project"></project-tasks>
              <component v-else :is="activeComponent"></component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProjectData from './Tabs/ProjectData.vue'
import ProjectNotes from './Tabs/ProjectNotes.vue'
import LastActivity from './Tabs/LastActivity.vue'
import ProjectTasks from './Tabs/ProjectTasks.vue'

export default {
  props: ['project'],
  data () {
    return {
      activeComponent: 'projectTasks'
    }
  },
  components: {
    projectData: ProjectData,
    projectNotes: ProjectNotes,
    lastActivity: LastActivity,
    projectTasks: ProjectTasks
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/Single/Content/Content.vue